module.exports = __webpack_public_path__ + "img/pin-blue-diamond.90d541b1.png";